import React, { useState, useRef } from 'react';
import { useStyles } from '@webapps/styles';
import { CloudUploadRounded as CloudUploadRoundedIcon } from '@material-ui/icons';
import { DoneRounded as DoneRoundedIcon } from '@material-ui/icons';

const FileUpload = () => {
  const { classes, cx } = useStyles(styles);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setUploadedFile(file);
    } else {
      // Gérer le cas où le fichier n'est pas un PDF si nécessaire
      console.log('Veuillez sélectionner un fichier PDF.');
    }
  };

  const handleContainerClick = () => {
    fileInputRef.current.click();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type === 'application/pdf') {
      setUploadedFile(file);
    } else {
      console.log('Veuillez déposer un fichier PDF.');
    }
  };

  return (
    <div className={classes.framerDiv13}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept=".pdf"
      />
      <div
        className={classes.framerButton}
        onClick={handleContainerClick}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        {uploadedFile ? (
          <DoneRoundedIcon className={classes.framerIcon1} />
        ) : (
          <CloudUploadRoundedIcon className={classes.framerIcon1} />
        )}
        <div className={classes.framerP8}>
          {uploadedFile
            ? `CV importé (${uploadedFile.name})`
            : 'Importer votre CV'}
        </div>
        <div className={classes.framerP6}>Glisser le fichier ici ou...</div>
        <div className={classes.framerButton2}>
          <div className={classes.framerP7}>Parcourir mes fichiers</div>
        </div>
      </div>
      <div className={classes.framerP9}>
        Ajoutez un fichier PDF inférieur à 5.00 MB.
      </div>
    </div>
  );
};

const styles = () => ({
  framerDiv13: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    height: 'min-content',
    justifyContent: 'flex-start',
    position: 'relative',
    width: '100%',
    gap: '10px',
    overflow: 'hidden',
  },
  framerButton: {
    cursor: 'pointer',
    border: '2px dashed #C0D9FF',
    alignContent: 'center',
    backgroundColor: '#f3f7ff',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    height: '222px',
    padding: '20px',
    position: 'relative',
    width: '100%',
    gap: '16px',
    overflow: 'visible',
    placeItems: 'center',
    '&:hover': {
      borderColor: '#0060f9',
    },
    '& framerButton2': {
      backgroundColor: '#004ac1',
    },
  },
  framerIcon1: {
    height: '48px',
    position: 'relative',
    width: '48px',
    fill: '#C0D9FF',
  },
  doneIcon: {
    color: '#008000',
  },
  framerP8: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '15px',
    fontWeight: '600',
    lineHeight: '15px',
    color: '#152652',
  },
  framerP6: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
    color: '#152652',
    width: '100%',
  },
  framerButton2: {
    alignContent: 'center',
    backgroundColor: '#0060f9',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    height: '40px',
    paddingBottom: '5px',
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingTop: '5px',
    position: 'relative',
    width: 'auto',
    gap: '10px',
    overflow: 'visible',
    placeItems: 'center',
    pointerEvents: 'none', 
  },
  framerP7: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '13.5px',
    fontWeight: '500',
    lineHeight: '23.625px',
    textAlign: 'center',
    color: '#ffffff',
  },
  framerP9: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '14px',
    textAlign: 'left',
    color: '#92abd2',
  },
});

export default FileUpload; 